import { filterSchedules, getPorts, getShips, } from "../../shared/models/api";
import React, { useEffect, useRef, useState } from "react";
import Pikaday from "pikaday";
import dt from "date-and-time";
export const Filter = (props) => {
    const { schedules } = props;
    const [submitting, setSubmitting] = useState(false);
    const pickerTo = useRef(null);
    const pickerFrom = useRef(null);
    const [to, setTo] = useState("");
    const [from, setFrom] = useState("");
    const [ship, setShip] = useState("");
    const [port, setPort] = useState("");
    const submit = (e) => {
        e.preventDefault();
        setSubmitting(true);
        const form = { ship, port, from, to };
        const data = Object.assign({}, form);
        const filtered = filterSchedules(data, schedules);
        props.setFiltered(filtered);
        setSubmitting(false);
    };
    useEffect(() => {
        try {
            const from = new Pikaday({
                format: "DD.MM.YYYY",
                field: pickerFrom.current,
                onSelect: (date) => {
                    if (date) {
                        setFrom(() => dt.format(date, "DD.MM.YYYY"));
                    }
                },
            });
            return () => {
                from === null || from === void 0 ? void 0 : from.destroy();
            };
        }
        catch (_a) {
        }
    }, []);
    useEffect(() => {
        try {
            const to = new Pikaday({
                format: "DD.MM.YYYY",
                field: pickerTo.current,
                onSelect: (date) => {
                    if (date) {
                        setTo(() => dt.format(date, "DD.MM.YYYY"));
                    }
                },
            });
            return () => {
                to === null || to === void 0 ? void 0 : to.destroy();
            };
        }
        catch (_a) {
        }
    }, []);
    const ships = schedules
        ? getShips(schedules, "alle", port)
        : [];
    return (React.createElement("form", { className: "form-filter form-box", onSubmit: (e) => submit(e) },
        React.createElement("fieldset", { disabled: !(ships === null || ships === void 0 ? void 0 : ships.length) },
            React.createElement("div", { className: "row row--2er" },
                React.createElement("label", { className: "select" },
                    React.createElement("select", { name: "ship", onChange: (e) => setShip(e.target.value) },
                        React.createElement("option", { value: "", defaultValue: "" }, "Bitte ausw\u00E4hlen"),
                        ships.map((shipname) => {
                            return (React.createElement("option", { key: shipname, value: shipname, defaultChecked: shipname === ship }, shipname));
                        })),
                    React.createElement("span", { className: "select__label" }, "Schiff")),
                React.createElement("label", { className: "select" },
                    React.createElement("select", { name: "port", onChange: (e) => setPort(e.target.value) },
                        React.createElement("option", { value: "", defaultValue: "" }, "Bitte ausw\u00E4hlen"),
                        schedules &&
                            getPorts(schedules, ship).map((portname) => {
                                return (React.createElement("option", { key: portname, value: portname, defaultChecked: portname === port }, portname));
                            })),
                    React.createElement("span", { className: "select__label" }, "Hafen"))),
            React.createElement("div", { className: "row row--2er" },
                React.createElement("label", { className: "textfield date" },
                    React.createElement("input", { id: "from", type: "text", name: "form", value: from, maxLength: 10, ref: pickerFrom, placeholder: "TT.MM.JJJJ", onInput: (e) => setFrom(e.target.value) }),
                    React.createElement("span", { className: "textfield__label" }, "Zeitraum von"),
                    React.createElement("i", { className: "fas fa-calendar" })),
                React.createElement("label", { className: "textfield date" },
                    React.createElement("input", { id: "to", name: "to", type: "text", value: to, ref: pickerTo, maxLength: 10, placeholder: "TT.MM.JJJJ", onChange: (e) => setTo(e.target.value) }),
                    React.createElement("span", { className: "textfield__label" }, "Zeitraum bis"),
                    React.createElement("i", { className: "fas fa-calendar" }))),
            React.createElement("div", { className: "tr" },
                React.createElement("button", { type: "submit", className: "btn btn--secondary", disabled: submitting || !(schedules === null || schedules === void 0 ? void 0 : schedules.length), onClick: (e) => submit(e) },
                    submitting ? (React.createElement("i", { className: "fas fa-spinner fa-spin mr2" })) : (React.createElement("i", { className: "fas fa-filter mr2" })),
                    "Termine anzeigen")))));
};
export default Filter;
